import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'

import { invoice as invoiceAdapter } from '../ports'
import { AggregatedInvoice } from 'Invoices/types'

export const fetchAggregatedInvoice = async (
  invoiceId: string
): Promise<AggregatedInvoice> => {
  const invoice = await dashboardv99990101Client.getInvoice({ id: invoiceId })

  if (!invoice.data || invoice.error) {
    throw new Error('Unable to fetch invoice')
  }

  const lineItems = await dashboardv99990101Client.getAllLineItems({
    invoiceId
  })

  if (!lineItems.data || lineItems.error) {
    throw new Error('Unable to fetch line items')
  }

  const lineItemGroups = await dashboardv99990101Client.getAllLineItemGroups({
    invoiceId
  })

  if (!lineItemGroups.data || lineItems.error) {
    throw new Error('Unable to fetch line item groups')
  }

  const customer = await dashboardv99990101Client.getCustomer({
    id: invoice.data.customerId
  })

  if (!customer.data || customer.error) {
    throw new Error('Unable to fetch customer')
  }

  const subAccountUsage =
    await dashboard20240730Client.getInvoiceUsageItemGroups({ invoiceId })

  if (!subAccountUsage.data || subAccountUsage.error) {
    throw new Error('Unable to fetch sub-account usage')
  }

  return invoiceAdapter.fromServer(
    invoice.data,
    lineItemGroups.data.items,
    lineItems.data.items,
    customer.data,
    subAccountUsage.data.items
  )
}
